/* eslint-disable */

import React from "react";
import { LineOutlined } from "@ant-design/icons";

// import 'antd/dist/antd.css';

interface Steps {
    iteration: number;
    activeIndex: number;
}

const Steps = (props: Steps) => {
    function render(iteration, activeIndex) {
        let stepperArr = [];

        for (var i = 0; i < iteration; i++) {
            if (i == activeIndex || i < activeIndex) {
                if (i == 0) {
                    stepperArr.push(
                        <div
                            key={i}
                            className="stepper-circle stepper-circle-active"
                        >
                            {i + 1}
                        </div>
                    );
                } else {
                    stepperArr.push(
                        <div
                            key={i + "dash"}
                            className="stepper-dash stepper-dash-active"
                        >
                            <LineOutlined />
                        </div>
                    );
                    stepperArr.push(
                        <div
                            key={i}
                            className="stepper-circle stepper-circle-active"
                        >
                            {i + 1}
                        </div>
                    );
                }
            } else {
                if (i == 0) {
                    stepperArr.push(
                        <div key={i} className="stepper-circle">
                            {i + 1}
                        </div>
                    );
                } else {
                    stepperArr.push(
                        <div key={i + "dash"} className="stepper-dash">
                            <LineOutlined />
                        </div>
                    );
                    stepperArr.push(
                        <div key={i} className="stepper-circle">
                            {i + 1}
                        </div>
                    );
                }
            }
        }

        return stepperArr;
    }

    return (
        <div className="stepper-container">
            {render(props.iteration, props.activeIndex)}
        </div>
    );
};

export default Steps;
